const initMuCardPods = () => {
    const colours = ['color-1', 'color-2', 'color-3', 'color-4'];
    const cards = document.querySelectorAll('.mu-card-pods');

    cards.forEach((card, index) => {
        card.classList.add(colours[index % colours.length]);
    });
};

document.addEventListener('DOMContentLoaded', initMuCardPods);

export default initMuCardPods;